'use client';

/**
 * Dropdown search input — a magnifier icon + a borderless input in a FLEX row, so the icon and the
 * placeholder/text can never overlap (the earlier absolute-icon-over-padded-input pattern collided
 * with the placeholder). Shared by the PhoneInput dial-code picker and the CountrySelect dropdown.
 */
export function SearchBox({
  value,
  onChange,
  placeholder,
  autoFocus,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  autoFocus?: boolean;
}) {
  return (
    <div className="flex items-center gap-2 border border-[#ced4da] rounded-lg px-3 py-1.5">
      <i className="fa-solid fa-magnifying-glass text-info text-xs shrink-0" aria-hidden="true" />
      <input
        autoFocus={autoFocus}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full bg-transparent border-none text-sm outline-none placeholder:text-info"
      />
    </div>
  );
}
